import React, { FC } from 'react';

export type BlurBoxProps = {
  children?: React.ReactNode;
};

export const BlurBox: FC<BlurBoxProps> = ({ children }: BlurBoxProps) => {
  return (
    <div className="p-12 rounded-sm bg-backdrop shadow-12dp">{children}</div>
  );
};
